// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__1q3i-","spinner":"Loader_spinner__1dvzu","rotate":"Loader_rotate__1DJXA","path":"Loader_path__Q2CQ6","dash":"Loader_dash__3-gOY"};